import { useApplication } from 'merchant-api/unified';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface UpdateLDRsProps {
  updateLDR: Function;
  isUpdateLDRsLoading: boolean;
  updateLDRsError: Error | null;
  mutation: UseMutationResult<any, Error, UpdateLDRsRequest[]>;
}

interface UpdateLDRsRequest {
  id: number;
  status: string | null;
}

export function updateLDRs(): UpdateLDRsProps {
  const { applicationData } = useApplication();

  const mutation = useMutation({
    mutationFn: (arg: UpdateLDRsRequest[]) =>
      spiceroad
        .patch(`/v1/ldr/${applicationData?.metadata?.sfOpportunityId}`, arg)
        .then((res) => res.data),
    mutationKey: ['updateLDRs', applicationData?.metadata?.sfOpportunityId],
  });

  return {
    isUpdateLDRsLoading: mutation.isPending,
    updateLDRsError: mutation.error,
    updateLDR: mutation.mutateAsync,
    mutation,
  };
}

export default updateLDRs;
